export default {
  attributeInserter: false,
  allowMediaInserter: false,
  allowCode: false,
  autoFocusBottomRight: true,
  markdownLinks: false,
  allowButton: false,
  allowSocial: false,
  allowHeading: true,
  allowSubheading: false,
  allowEmoji: true,
  allowAlignment: false
};